var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPremiumBrandschutz = function SvgPremiumBrandschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.226,
    height: 88.774
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brandschutz_svg__a",
    x1: 49.979,
    x2: 48.739,
    y1: 81.567,
    y2: 12.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brandschutz_svg__a",
    id: "premium-brandschutz_svg__f",
    x1: 24.578,
    x2: 23.338,
    y1: 82.02,
    y2: 12.589
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brandschutz_svg__b",
    x1: 30.581,
    x2: 15.484,
    y1: 75.789,
    y2: 19.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brandschutz_svg__b",
    id: "premium-brandschutz_svg__g",
    x1: 48.203,
    x2: 57.626,
    y1: 73.038,
    y2: 3.607
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brandschutz_svg__h",
    x1: 47.807,
    x2: 51.738,
    y1: 85.053,
    y2: 30.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brandschutz_svg__c",
    x1: 40.058,
    x2: 36.993,
    y1: 94.472,
    y2: 62.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcefb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dc5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brandschutz_svg__c",
    id: "premium-brandschutz_svg__i",
    x1: 0.878,
    x2: 75.348,
    y1: 77.445,
    y2: 77.445
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brandschutz_svg__d",
    x1: 22.774,
    x2: 29.57,
    y1: 79.102,
    y2: 73.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fae588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dc5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-brandschutz_svg__e",
    x1: 28.759,
    x2: 21.802,
    y1: 76.713,
    y2: 74.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brandschutz_svg__d",
    id: "premium-brandschutz_svg__j",
    x1: 34.703,
    x2: 41.5,
    y1: 79.102,
    y2: 73.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brandschutz_svg__e",
    id: "premium-brandschutz_svg__k",
    x1: 40.688,
    x2: 33.731,
    y1: 76.713,
    y2: 74.233
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brandschutz_svg__d",
    id: "premium-brandschutz_svg__l",
    x1: 46.632,
    x2: 53.429,
    y1: 79.102,
    y2: 73.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#premium-brandschutz_svg__e",
    id: "premium-brandschutz_svg__m",
    x1: 52.617,
    x2: 45.66,
    y1: 76.713,
    y2: 74.233
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__a)",
    d: "M60.164 78.925c-5.99 5.353-13.628 8.8-21.392 8.6a47 47 0 0 1-7.083-.707c-6.326-6.166-5.539-17.147 1.368-24.264 5.41-5.572 9.92-12.143 10.656-20.003.488-5.187-.664-10.935-4.283-17.327-8.103-14.312-.253-22.372 2.995-24.902.17-.106.342-.216.515-.322 0 0-2.72 10.749 8.152 24.941 8.04 11.759 9.215 27.054 5.675 36.06 9.553-4.281 6.25-24.092 6.25-24.092 14.836 11.931 9.476 31.005-2.853 42.016"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__f)",
    d: "M33.057 62.554c-6.907 7.117-7.694 18.098-1.368 24.264C12.197 83.322 1.226 67.353 4.94 43.942c1.62 6.485 1.261 10.447 9.725 18.37-6.19-12.223-13.222-30.327 14.93-52.951-1.76 4.237-3.779 12.867 4.071 20.717a89 89 0 0 1 10.048 12.473c-.737 7.86-5.246 14.431-10.656 20.003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__b)",
    d: "M33.059 62.554c-6.237 6.878-7.568 16.713-2.49 23.029C13.61 81.98 4.282 68.64 5.295 49.936c1.026 3.868 2.766 7.56 8.687 13.103a1 1 0 0 0 .684.269.996.996 0 0 0 .887-1.445c-3.304-6.528-6.237-13.71-5.313-22.016.946-8.506 4.255-14.31 11.947-22.132a1.297 1.297 0 0 1 2.207.77c.489 3.657 3.853 6.856 8.565 12.297 3.006 3.47 9.354 9.609 9.782 13.68.151 1.432-.677 8.162-9.682 18.092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__g)",
    d: "M59.501 78.181c-6.03 5.39-13.166 8.358-20.09 8.358q-.304 0-.614-.01a45.6 45.6 0 0 1-6.93-.69q-.656-.118-1.298-.256c-5.078-6.316-3.978-16.367 2.49-23.029 5.18-5.336 10.053-11.68 11.646-19.91 1.099-5.682-.94-11.789-4.407-17.912-6.678-11.788-2.135-19.04 1.355-22.421-.2 4.1.61 12.735 8.63 23.215a43.25 43.25 0 0 1 7 18.608c.814 6.087.286 12.1-1.444 16.5a.996.996 0 0 0 .93 1.362 1 1 0 0 0 .405-.086c8.039-3.603 7.71-16.78 7.156-22.507A21.25 21.25 0 0 1 71 54.329c.217 8.311-4.084 17.23-11.499 23.852"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__h)",
    d: "M40.298 24.732c3.467 6.123 5.506 12.23 4.407 17.911-1.593 8.231-6.465 14.575-11.646 19.911-6.468 6.662-7.568 16.713-2.49 23.029q.642.138 1.298.255a45.6 45.6 0 0 0 6.93.691q.31.01.614.01c6.924 0 14.06-2.969 20.09-8.358 7.415-6.621 11.716-15.54 11.5-23.852 0 0-4.597 17.317-19.98 17.317s-1.977-15.492-.854-20.681c3.59-16.579-9.869-26.233-9.869-26.233",
    opacity: 0.99
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e03616",
    d: "M28.231 70.629a19.8 19.8 0 0 1 3.458-6.9c.804-1.036 1.732-1.936 2.567-2.9a60 60 0 0 0 2.464-2.94 36.4 36.4 0 0 0 7.04-13.39 18.1 18.1 0 0 0 .627-7.451 29.4 29.4 0 0 0-2.02-7.302 45 45 0 0 0-1.59-3.481c-.575-1.135-1.224-2.262-1.756-3.447a22.8 22.8 0 0 1-2.03-7.45 24.2 24.2 0 0 0 2.47 7.24c.57 1.14 1.241 2.225 1.872 3.362a46 46 0 0 1 1.74 3.476 27.3 27.3 0 0 1 2.214 7.487 19.4 19.4 0 0 1 .129 3.944 21 21 0 0 1-.695 3.878 36 36 0 0 1-7.409 13.615c-.837.988-1.699 1.953-2.595 2.884-.886.947-1.835 1.815-2.652 2.781a20.8 20.8 0 0 0-3.834 6.594"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__c)",
    d: "M70.66 88.69a95.7 95.7 0 0 0-65.095 0 1.536 1.536 0 0 1-1.963-1.169L.078 74.944a1.9 1.9 0 0 1 1.024-2.312 108.37 108.37 0 0 1 74.022 0 1.903 1.903 0 0 1 1.024 2.312L72.624 87.52a1.536 1.536 0 0 1-1.963 1.17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__i)",
    d: "M71.132 87.756a.6.6 0 0 1-.212-.037 96.47 96.47 0 0 0-65.614 0 .6.6 0 0 1-.212.037.704.704 0 0 1-.657-.55L.913 74.63A.93.93 0 0 1 .958 74a.72.72 0 0 1 .405-.396 107.62 107.62 0 0 1 73.5 0 .72.72 0 0 1 .405.396.93.93 0 0 1 .045.63l-3.525 12.578a.704.704 0 0 1-.656.548"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__d)",
    d: "m26.4 70.971 1.262 2.555a.24.24 0 0 0 .182.132l2.82.41a.242.242 0 0 1 .133.413l-2.04 1.988a.24.24 0 0 0-.07.214l.482 2.809a.242.242 0 0 1-.35.255l-2.523-1.326a.24.24 0 0 0-.225 0l-2.522 1.326a.242.242 0 0 1-.35-.255l.481-2.809a.24.24 0 0 0-.07-.214l-2.04-1.988a.242.242 0 0 1 .134-.413l2.82-.41a.24.24 0 0 0 .182-.132l1.261-2.555a.242.242 0 0 1 .434 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__e)",
    d: "M26.184 70.836a.24.24 0 0 1 .217.135l1.26 2.555a.24.24 0 0 0 .183.132l2.82.41a.242.242 0 0 1 .133.413l-2.04 1.988a.24.24 0 0 0-.07.214l.482 2.809a.241.241 0 0 1-.35.255l-2.523-1.326a.24.24 0 0 0-.225 0l-2.522 1.326a.241.241 0 0 1-.35-.255l.481-2.809a.24.24 0 0 0-.07-.214l-2.04-1.988a.242.242 0 0 1 .134-.413l2.82-.41a.24.24 0 0 0 .182-.132l1.261-2.555a.24.24 0 0 1 .217-.135m0-.25a.49.49 0 0 0-.442.274l-1.26 2.555-2.814.405a.492.492 0 0 0-.273.84l2.04 1.989-.483 2.8a.492.492 0 0 0 .714.52l2.522-1.327 2.514 1.326a.492.492 0 0 0 .714-.519l-.482-2.808 2.038-1.981a.492.492 0 0 0-.273-.84l-2.82-.41-1.254-2.55a.49.49 0 0 0-.441-.274",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m23.379 79.735.482-2.808a.24.24 0 0 0-.07-.214l-.117-.114a.2.2 0 0 1 .006.084l-.482 2.809a.237.237 0 0 0 .184.27c0-.01-.005-.017-.003-.027M27.842 73.77a.24.24 0 0 0 .182.132l2.82.41c.007 0 .012.006.019.008a.236.236 0 0 0-.2-.252l-2.82-.41a.2.2 0 0 1-.07-.028ZM21.885 74.311l2.82-.41a.24.24 0 0 0 .182-.132l1.26-2.555a.24.24 0 0 1 .321-.106l-.067-.137a.242.242 0 0 0-.434 0l-1.26 2.555a.24.24 0 0 1-.183.132l-2.82.41a.242.242 0 0 0-.134.413l.114.11a.24.24 0 0 1 .2-.28"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__j)",
    d: "m38.33 70.971 1.26 2.555a.24.24 0 0 0 .183.132l2.82.41a.242.242 0 0 1 .133.413l-2.04 1.988a.24.24 0 0 0-.07.214l.482 2.809a.242.242 0 0 1-.35.255l-2.522-1.326a.24.24 0 0 0-.226 0l-2.521 1.326a.242.242 0 0 1-.351-.255l.481-2.809a.24.24 0 0 0-.07-.214l-2.04-1.988a.242.242 0 0 1 .134-.413l2.82-.41a.24.24 0 0 0 .182-.132l1.261-2.555a.242.242 0 0 1 .434 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__k)",
    d: "M38.113 70.836a.24.24 0 0 1 .217.135l1.26 2.555a.24.24 0 0 0 .183.132l2.82.41a.242.242 0 0 1 .134.413l-2.04 1.988a.24.24 0 0 0-.07.214l.481 2.809a.241.241 0 0 1-.35.255l-2.522-1.326a.24.24 0 0 0-.226 0l-2.521 1.326a.241.241 0 0 1-.351-.255l.481-2.809a.24.24 0 0 0-.07-.214l-2.04-1.988a.242.242 0 0 1 .134-.413l2.82-.41a.24.24 0 0 0 .182-.132l1.261-2.555a.24.24 0 0 1 .217-.135m0-.25a.49.49 0 0 0-.441.274l-1.261 2.555-2.814.405a.492.492 0 0 0-.272.84l2.04 1.989-.484 2.8a.492.492 0 0 0 .714.52l2.522-1.327 2.514 1.326a.492.492 0 0 0 .714-.519l-.481-2.808L42.9 74.66a.492.492 0 0 0-.273-.84l-2.82-.41-1.254-2.55a.49.49 0 0 0-.441-.274",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m35.308 79.735.482-2.808a.24.24 0 0 0-.07-.214l-.117-.114a.2.2 0 0 1 .006.084l-.481 2.809a.237.237 0 0 0 .183.27c0-.01-.005-.017-.003-.027M39.771 73.77a.24.24 0 0 0 .182.132l2.82.41c.007 0 .012.006.019.008a.236.236 0 0 0-.2-.252l-2.82-.41a.2.2 0 0 1-.07-.028ZM33.814 74.311l2.82-.41a.24.24 0 0 0 .182-.132l1.26-2.555a.24.24 0 0 1 .321-.106l-.067-.137a.242.242 0 0 0-.434 0l-1.26 2.555a.24.24 0 0 1-.183.132l-2.82.41a.242.242 0 0 0-.133.413l.113.11a.24.24 0 0 1 .201-.28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__l)",
    d: "m50.259 70.971 1.261 2.555a.24.24 0 0 0 .182.132l2.82.41a.242.242 0 0 1 .134.413l-2.04 1.988a.24.24 0 0 0-.07.214l.481 2.809a.242.242 0 0 1-.35.255l-2.522-1.326a.24.24 0 0 0-.225 0l-2.522 1.326a.242.242 0 0 1-.351-.255l.481-2.809a.24.24 0 0 0-.07-.214l-2.04-1.988a.242.242 0 0 1 .135-.413l2.82-.41a.24.24 0 0 0 .181-.132l1.261-2.555a.242.242 0 0 1 .434 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#premium-brandschutz_svg__m)",
    d: "M50.042 70.836a.24.24 0 0 1 .217.135l1.261 2.555a.24.24 0 0 0 .182.132l2.82.41a.242.242 0 0 1 .134.413l-2.04 1.988a.24.24 0 0 0-.07.214l.481 2.809a.241.241 0 0 1-.35.255l-2.522-1.326a.24.24 0 0 0-.225 0l-2.522 1.326a.241.241 0 0 1-.351-.255l.481-2.809a.24.24 0 0 0-.07-.214l-2.04-1.988a.242.242 0 0 1 .135-.413l2.82-.41a.24.24 0 0 0 .181-.132l1.261-2.555a.24.24 0 0 1 .217-.135m0-.25a.49.49 0 0 0-.441.274l-1.261 2.555-2.813.405a.492.492 0 0 0-.273.84l2.04 1.989-.484 2.8a.492.492 0 0 0 .714.52l2.522-1.327 2.514 1.326a.492.492 0 0 0 .714-.519l-.481-2.808 2.037-1.981a.492.492 0 0 0-.272-.84l-2.82-.41-1.254-2.55a.49.49 0 0 0-.442-.274",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2c756",
    d: "m47.237 79.735.482-2.808a.24.24 0 0 0-.07-.214l-.117-.114a.2.2 0 0 1 .006.084l-.481 2.809a.237.237 0 0 0 .183.27c0-.01-.004-.017-.003-.027M51.7 73.77a.24.24 0 0 0 .183.132l2.82.41c.007 0 .01.006.018.008a.236.236 0 0 0-.2-.252l-2.819-.41a.2.2 0 0 1-.07-.028ZM45.743 74.311l2.82-.41a.24.24 0 0 0 .182-.132l1.26-2.555a.24.24 0 0 1 .322-.106l-.068-.137a.242.242 0 0 0-.434 0l-1.26 2.555a.24.24 0 0 1-.183.132l-2.82.41a.242.242 0 0 0-.133.413l.113.11a.24.24 0 0 1 .201-.28"
  }))));
};
export default SvgPremiumBrandschutz;